export default "__VITE_ASSET__Bbw51Rna__"